import { defineQueryOptions } from '@pinia/colada';
import { api, ApiError } from './client.ts';
import type { components } from './schema.gen.ts';
import { messageOf } from './serverFailure.ts';

export type SpotifyPlaylist = components['schemas']['SpotifyPlaylist'];

export const noHostSignIn = 'no-host-sign-in';

export const playlistKeys = {
  mine: ['host-playlists'] as const,
};

export const hostPlaylistsQuery = defineQueryOptions({
  key: playlistKeys.mine,
  query: async (): Promise<SpotifyPlaylist[]> => {
    const { data, error, response } = await api.GET('/spotify/playlists');
    if (!data) throw new ApiError(response.status, error && messageOf('hostPlaylists', error), error?.slug);
    return data.playlists;
  },
});

export const searchPlaylists = async (search: string): Promise<SpotifyPlaylist[]> => {
  const { data, error, response } = await api.GET('/spotify/playlists/search', { params: { query: { q: search } } });
  if (!data) throw new ApiError(response.status, error && messageOf('searchPlaylists', error), error?.slug);
  return data.playlists;
};
